import User from 'src/models/Users/User'
import Vue from 'vue'
import {Dictionary, Module} from 'vuex'
import {RootState, UserState} from '@/types/store/states'
import {RawUser} from '@/types/entity/RawUser'
import $store from '@/store'
import {API, LANG} from '@/constants'
import auth from '@/services/auth'
import {langChecked} from '@/lang/index';
import {setCheckedLang} from '@/services/langStorage';
import config from '@/config'

const store: Module<UserState, RootState> = {
  namespaced: true,
  state: {
    user: false,
    userAccessTokenFailedCount: 0
  },
  getters: {
    getUser: state => (data: RawUser) => {
      Vue.set(state, 'user', new User(data))
      return state.user
    }
  },
  mutations: {
    user: (state, user) => {
      state.user = user
    },
    incrementUserAccessTokenFailedCount: (state) => {
      state.userAccessTokenFailedCount += 1
    },
    emptyUserAccessTokenFailedCount: (state) => {
      state.userAccessTokenFailedCount = 0
    }
  },
  actions: {
    /**
     * Load user
     * @param {*} context
     * @returns {Promise<User|User[]>}
     */
    async loadUser (context, data) {
      try {
        const response = await context.dispatch('apiRequest', {
          method: API.cproc.lsnInfo,
          flag: 'silent',
          data
        }, {root: true})

        if (!response && context.state.userAccessTokenFailedCount < 2) {
          context.commit('incrementUserAccessTokenFailedCount')
          return
        }

        context.commit('emptyUserAccessTokenFailedCount')

        if (response.lang) {
          setCheckedLang(response.lang);
        }

        return context.getters.getUser(response)
      } catch (error) {
        console.error('loadUser: error', error)
        auth.logout();
        throw error;
      }
    },
    async getCode (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.cproc.getCode,
        data
      }, {root: true})
      return response;
    },
    async dropAuth (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.cproc.dropAuth,
        data
      }, {root: true})
      return response;
    },
    async userProfileUpdate (context, data) {
      const response = await context.dispatch('apiRequest', {
        url: API.cproc.profileUpdate,
        data,
        flag: 'silent'
      }, {root: true})
      console.log('LOG: userProfileUpdate -> response', response)
    }
  }
}

export default store